import { render, staticRenderFns } from "./FixedPriceTaskAdd.vue?vue&type=template&id=1608bc58&scoped=true"
import script from "./FixedPriceTaskAdd.vue?vue&type=script&lang=js"
export * from "./FixedPriceTaskAdd.vue?vue&type=script&lang=js"
import style0 from "./FixedPriceTaskAdd.vue?vue&type=style&index=0&id=1608bc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608bc58",
  null
  
)

export default component.exports